import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: theme.spacing(1),
		"& > *": {
			margin: 0,
		},
		[theme.breakpoints.down("sm")]: {
			marginLeft: 0,
			width: "100%",
			"& .MuiButton-root": {
				flex: "1 1 auto",
				minWidth: 0,
			},
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children, className }) => {
	const classes = useStyles();

	return <div className={`${classes.MainHeaderButtonsWrapper} ${className || ""}`}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
